import { render, staticRenderFns } from "./setup-create-scenario.vue?vue&type=template&id=7674ff08&scoped=true"
import script from "./setup-create-scenario.vue?vue&type=script&lang=ts"
export * from "./setup-create-scenario.vue?vue&type=script&lang=ts"
import style0 from "./setup-create-scenario.vue?vue&type=style&index=0&id=7674ff08&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7674ff08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7674ff08')) {
      api.createRecord('7674ff08', component.options)
    } else {
      api.reload('7674ff08', component.options)
    }
    module.hot.accept("./setup-create-scenario.vue?vue&type=template&id=7674ff08&scoped=true", function () {
      api.rerender('7674ff08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setup/scenario/setup-create-scenario.vue"
export default component.exports